import { axios } from '@/utils/request'

const api = {
  storageRecord: '/stock/record'
}
const api2 = {
  storageRecord: '/stock/useRecord'
}
const api3 = {
  accessory: '/stock/accessory'
}
const api4 = {
  store: '/stock/store'
}
const api5 = {
  province: '/basicdata/province',
  city: '/basicdata/city',
  area: '/basicdata/area',
  street: '/basicdata/street',
}
// 导出(使用记录)
export function useRecordExport (parameter) {
  return axios({
    url: api2.storageRecord + '/useRecordExport',
    method: 'get',
    params: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }

  })
}

// 导出(出入库记录)
export function storageRecordExport2 (parameter) {
  return axios({
    url: api.storageRecord + '/storageRecordExport',
    method: 'get',
    params: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }

  })
}

// 市
export function selectCityName (parameter) {
  console.log(parameter)
  return axios({
    url: api5.city + '/selectCityName',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 多个市
export function provinceCodeList (parameter) {
  console.log(parameter)
  return axios({
    url: api5.city + '/provinceCodeList',
    method: 'get',
    params: parameter,

  })
}
// 省
export function selectAllProvince (parameter) {
  return axios({
    url: api5.province + '/selectAllProvince',
    method: 'post',
    params: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 服务区域
export function area (parameter) {
  return axios({
    url: api4.store + '/area',
    method: 'post',
    data: parameter
  })
}

// 详情
export function getoneaccessory (parameter) {
  return axios({
    url: api3.accessory + '/getoneaccessory',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function storagerecordlis (parameter) {
  return axios({
    url: api.storageRecord + '/storagerecordlist',
    method: 'get',
    params: parameter
  })
}

export function userecordlist (parameter) {
  return axios({
    url: api2.storageRecord + '/userecordlist',
    method: 'get',
    params: parameter
  })
}


export function saveStorageRecord (parameter) {
  return axios({
    url: api.storageRecord+(parameter.storageRecordId > 0 ? '/update' : '/save'),
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function delStorageRecord (parameter) {
  return axios({
    url: api.storageRecord + '/remove',
    method: 'post',
    params: parameter
  })
}

export const storageRecordExport = api.storageRecord + '/export'
